import { colors } from "@/design-system/theme/colors";
import { Label } from "@/design-system/components";

const ColorPicker: React.FC<{
  value: string;
  onChange: (color: string) => void;
  onBlur?: () => void;
  label: string;
  required?: boolean;
  helperText?: string;
  error?: string;
}> = ({ value, onChange, onBlur, label, required, helperText, error }) => (
  <div className="flex flex-col gap-1.5">
    <Label size="medium" weight={500} required={required}>
      {label}
    </Label>
    <div
      className="relative flex items-center h-10 rounded overflow-hidden border cursor-pointer"
      style={{ borderColor: error ? colors.error : colors.surfaceSubtle }}
    >
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
      />
      <div
        className="flex-1 h-full flex items-center px-3"
        style={{ backgroundColor: value }}
      >
        <span
          className="text-sm font-medium"
          style={{ color: "#fff", textShadow: "0 1px 2px rgba(0,0,0,0.3)" }}
        >
          {value.toUpperCase()}
        </span>
      </div>
      <div
        className="w-10 h-full flex items-center justify-center"
        style={{ backgroundColor: value }}
      >
        <div
          className="w-5 h-5 rounded-full border-2 border-white shadow"
          style={{ backgroundColor: value }}
        />
      </div>
    </div>
    {error ? (
      <span className="text-xs" style={{ color: colors.error }}>
        {error}
      </span>
    ) : helperText ? (
      <span className="text-xs" style={{ color: colors.textMuted }}>
        {helperText}
      </span>
    ) : null}
  </div>
);

export default ColorPicker;

